/**
 * @const {number} AUDIT_LOGS_PAGE_SIZE has to be in sync with the BE implementation.
 * This tells us whether there is more data to pull or not.
 */
export const AUDIT_LOGS_PAGE_SIZE = 40;

export const AUDIT_LOGS_FILTER_HEIGHT = "40px";
export const AUDIT_LOGS_FILTER_WIDTH = "232px";
